import React from "react";
import { Chip } from "@mui/material";
import typography from "../cssUtils/typography";

const AppChip = ({
  label,
  color = "default",
  variant = "filled", // 'filled' or 'outlined'
  size = "small",
  icon,
  onDelete,
  sx = {},
  ...props
}) => {
  return (
    <Chip
      label={label}
      color={color}
      variant={variant}
      size={size}
      icon={icon}
      onDelete={onDelete}
      sx={{
        ...typography.bodySmall,
        fontWeight: 500,
        height: 24,
        ...sx,
      }}
      {...props}
    />
  );
};

export default AppChip;